import Box from '@mui/material/Box'
import Pagination from '@mui/material/Pagination'
import Typography from '@mui/material/Typography'
import useTheme from '@mui/material/styles/useTheme'
import useMediaQuery from '@mui/material/useMediaQuery'

import Grid from '@mui/material/Grid2'
import { FC } from 'react'
import { MofiSortType, SortDirectionDTO } from '../../apis'

export const getNewPageAfterItemDeletion = (
  pagination: MoovyPaginationProps | undefined,
): number | undefined => {
  if (!pagination || !pagination.page || pagination.page <= 1) {
    return undefined
  }

  const totalNumberOfPages =
    pagination.limit > 0 ? Math.ceil(pagination.total / pagination.limit) : 0

  if (totalNumberOfPages <= 1) {
    return undefined
  }

  const lastItems = pagination.total % pagination.limit || pagination.limit
  if (lastItems !== 1) {
    return undefined
  }

  if (pagination.page === totalNumberOfPages) {
    return pagination.page - 1
  }

  return undefined
}

export type PaginationAndSortingValues = {
  page: number
  limit: number
  sort: MofiSortType
  direction: SortDirectionDTO
}

export type MoovyPaginationProps = {
  onNextPage: (page: number) => void
  page?: number
  total: number
  limit: number
}

const MoovyPagination: FC<MoovyPaginationProps> = ({
  page,
  total,
  limit,
  onNextPage,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const totalNumberOfPages =
    total > 0 && limit > 0 ? Math.ceil(total / limit) : 0

  const start = page ? page * limit - limit + 1 : 0
  const end = Math.min(start + limit - 1, total)

  return (
    <Grid
      container
      direction="row"
      sx={{ paddingTop: 2, alignItems: 'center' }}
    >
      <Grid size={{ md: 12 }} sx={{ pl: 2, pb: { xs: 2, md: 0 } }}>
        <Box
          sx={{ justifyContent: { xs: 'center', md: 'left' } }}
          display={'flex'}
          alignItems={'center'}
        >
          <Typography color="text.secondary">{`${start} - ${end} / ${total}`}</Typography>
        </Box>
      </Grid>
      <Grid size={{ md: 12 }} sx={{ pb: { xs: 1, md: 0 } }}>
        <Box
          sx={{ justifyContent: { xs: 'center', md: 'right' } }}
          display={'flex'}
          alignItems={'center'}
        >
          <Pagination
            page={page}
            siblingCount={1}
            boundaryCount={0}
            count={totalNumberOfPages}
            shape="rounded"
            showFirstButton={!isMobile}
            showLastButton={!isMobile}
            onChange={(_event, page) => onNextPage(page)}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default MoovyPagination
